import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import RouteIcon from "@mui/icons-material/Route";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import FourKOutlinedIcon from "@mui/icons-material/FourKOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

import ContactForm from "../components/ContactForm";
import "../styles/Drones.css";
import fondo from "../assets/drone.jpg";
import SliderDrone from "../components/SliderDron";
import WhatsAppButton from "../components/WhatsAppButton";

const inmobiliario = [
  {
    imagen: "../assets/chacra.jpg",
    titulo: "Chacras",
  },
  {
    imagen: "../assets/campo.jpg",
    titulo: "Terrenos",
  },
  {
    imagen: "../assets/casa.jpg",
    titulo: "Casas",
  },
  {
    imagen: "../assets/edificio-apartamentos.jpg",
    titulo: "Apartamentos",
  },
];

const producciones = [
  {
    imagen: "../assets/supermercado.jpg",
    titulo: "Emprendimientos",
  },
  {
    imagen: "../assets/auto.jpg",
    titulo: "Generación de contenido",
  },
  {
    imagen: "../assets/evento.jpg",
    titulo: "Eventos",
  },
];

const Drones = () => {
  return (
    <Box className="drones" sx={{ paddingTop: "86px", bgcolor: "#fafafa" }}>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url(${fondo})`,
          color: "white",
          height: "500px",
          width: isMobile ? "96%" : "100%",
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center",
          margin: "0 auto",
          paddingTop: isMobile ? "1rem" : "2rem",
        }}
      >
        {/* Overlay negro */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />
        <Typography sx={{ position: "relative", zIndex: 10 }} variant="h1">
          Tomas aereas con Drones
        </Typography>
        <Typography
          variant="h3"
          sx={{ mt: 2, position: "relative", zIndex: 10 }}
        >
          Trabajos profesionales de filmación, fotografía y edición
        </Typography>
        <Button
          variant="contained"
          color="success"
          sx={{
            mt: 1,
            fontWeight: "bold",
            position: "relative",
            zIndex: 10,
          }}
          href={"/drones#contacto"}
        >
          Contacto
        </Button>
      </Box>

      {/* Servicios */}

      <Container sx={{ marginBottom: isMobile ? "2rem" : "4rem" }}>
        <Grid
          container
          sx={{
            alignItems: "center",
            justifyContent: "center",
            marginTop: isMobile ? "2rem" : "4rem",
            width: "100%",
          }}
          //  spacing={isMobile ? 0 : 4}
        >
          {[
            {
              id: 1,
              nombre: "Imágenes de alta calidad",
              detalle:
                "Camara de alta resolución para resultados profesionales",
            },
            {
              id: 2,
              nombre: "Piloto  certificado",
              detalle: "Piloto profesional certificado por DINACIA",
            },
            {
              id: 3,
              nombre: "Rápida entrega",
              detalle: "Servicio de edición y entrega del contenido en 48 hs",
            },
          ].map((item) => {
            return (
              <Grid
                sx={{
                  height: "250px",
                  width: isMobile ? "96%" : "300px",
                  position: "relative",
                  margin: "0 auto",
                  paddingLeft: "0 !important",
                  marginBottom: isMobile ? ".6rem" : "0",
                }}
                item
                xs={12}
                sm={6}
                md={4}
                p={0}
                key={item.id}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#ffffff",
                    margin: "0 auto",
                    borderRadius: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: isMobile ? "100%" : "94%",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {item.id == 1 ? (
                    <FourKOutlinedIcon color="info" fontSize="large" />
                  ) : item.id == 2 ? (
                    <VerifiedUserOutlinedIcon color="info" fontSize="large" />
                  ) : (
                    <AccessTimeOutlinedIcon color="info" fontSize="large" />
                  )}
                  <Typography
                    variant="h6"
                    textTransform="uppercase"
                    color="info"
                    sx={{ mt: 1, color: "#0288d1" }}
                  >
                    {item.nombre}
                  </Typography>
                  <Typography
                    variant="body-1"
                    // textTransform="uppercase"
                    color="info"
                    sx={{ mt: 1, color: "#0288d1", width: "85%" }}
                  >
                    {item.detalle}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>

      <Box py="2rem" sx={{ bgcolor: "#fff3e0" }}>
        <Typography
          variant="h4"
          mb="2rem"
          textTransform="uppercase"
          gutterBottom
        >
          Servicios
        </Typography>

        <Container>
          <Typography
            variant="h6"
            mb="2rem"
            textTransform="uppercase"
            gutterBottom
          >
            Inmobiliarias
          </Typography>
          <Box>
            <SliderDrone slides={inmobiliario}></SliderDrone>
          </Box>
        </Container>
         <Container>
          <Typography
            variant="h6"
            mb="2rem"
            textTransform="uppercase"
            gutterBottom
          >
            Producciones
          </Typography>
          <Box>
            <SliderDrone slides={producciones}></SliderDrone>
          </Box>
        </Container>
      </Box>

      {/* Formulario de Contacto */}
      <Divider />
       <WhatsAppButton id="btn-whatsapp-drone" srOnly='Whatsapp drone' message ="Hola, necesito información sobre un servicio de Drones"/>
      <ContactForm placeholder="Información de utilidad: dirección y localidad" id="drone" />
    </Box>
  );
};

export default Drones;
